import React from 'react'

//
import ButtonNew from '../ButtonNew'
import Socials from '../Socials'
import { BUTTON_VARIANT } from '../ButtonNew/ButtonNew'

const CareersHeadingShareSection = ({ shareLabel, socials = [], applyCta }) => (
  <div className="c-careers__share l-grid l-grid--default-spacing l-grid--align:middle">
    <div className="c-careers__share-social l-grid__col:6/12@at:viewport-7">
      <div className="c-careers__share-label">{shareLabel}</div>
      <div className="c-careers__share-socials">
        {socials ? <Socials socials={socials} /> : null}
      </div>
    </div>
    {applyCta ? (
      <div className="c-careers__share-action l-grid__col:6/12@at:viewport-7">
        <ButtonNew
          variant={BUTTON_VARIANT.GREEN}
          url=""
          buttonProps={{ onClick: applyCta?.onClickHandler }}
        >
          {applyCta?.label}
        </ButtonNew>
      </div>
    ) : null}
  </div>
)

export default CareersHeadingShareSection
